import { render, staticRenderFns } from "./person.vue?vue&type=template&id=7cfe5eef&scoped=true"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"
import style0 from "./person.vue?vue&type=style&index=0&id=7cfe5eef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfe5eef",
  null
  
)

export default component.exports